module.exports = {
  SAVE_CUSTOM_TABLES: 'SAVE_CUSTOM_TABLES',
  APPEND_CUSTOM_TABLES: 'APPEND_CUSTOM_TABLES',
  SET_CUSTOM_TABLES_PAGINATION_DATA: 'SET_CUSTOM_TABLES_PAGINATION_DATA',
  SELECT_CUSTOM_TABLE: 'SELECT_CUSTOM_TABLE',
  SET_CUSTOM_TABLES_FILTER: 'SET_CUSTOM_TABLES_FILTER',
  UPDATE_CUSTOM_TABLE: 'UPDATE_CUSTOM_TABLE',
  RESET_CUSTOM_TABLES_FILTERS: 'RESET_CUSTOM_TABLES_FILTERS',
  RESET_CUSTOM_TABLES_DATA: 'RESET_CUSTOM_TABLES_DATA',
  RESET_CUSTOM_TABLE_PAGINATION_DATA: 'RESET_CUSTOM_TABLE_PAGINATION_DATA',
  SET_CUSTOM_TABLES_OPERATIONAL_MODE: 'SET_CUSTOM_TABLES_OPERATIONAL_MODE',
  ADD_FIELD_TO_TABLE: 'ADD_FIELD_TO_TABLE',
  UPDATE_FIELD: 'UPDATE_FIELD',
  DELETE_FIELD: 'DELETE_FIELD',
  SET_SELECTED_FIELD: 'SET_SELECTED_FIELD',
  SET_CUSTOM_TABLE_DATA: 'SET_CUSTOM_TABLE_DATA',
  SET_CUSTOM_TABLE_ROWS: 'SET_CUSTOM_TABLE_ROWS',
  ADD_CUSTOM_TABLE_ROW: 'ADD_CUSTOM_TABLE_ROW',
  UPDATE_CUSTOM_TABLE_ROW: 'UPDATE_CUSTOM_TABLE_ROW',
  DELETE_CUSTOM_TABLE_ROW: 'DELETE_CUSTOM_TABLE_ROW',
  SET_SELECTED_ROW: 'SET_SELECTED_ROW',
  SET_CUSTOM_TABLE_ROWS_PAGINATION: 'SET_CUSTOM_TABLE_ROWS_PAGINATION',
  RESET_CUSTOM_TABLE_ROWS_DATA: 'RESET_CUSTOM_TABLE_ROWS_DATA',
  UPDATE_CUSTOM_TABLE_SNIPPET_ON_STATE: 'UPDATE_CUSTOM_TABLE_SNIPPET_ON_STATE',
  SAVE_CUSTOM_TABLE_LIMITS: 'SAVE_CUSTOM_TABLE_LIMITS',
}; 